import { pickI18nBlob } from "@/components/admin/I18nField";
import type {
  CartDeliveryLadderOption,
  CartLadderFallback,
} from "@/api/queries/cart";

/**
 * KAN-1921 — lidský název úrovně, na kterou operace spadla, když zvolenou
 * rychlost nemá. Pokladna dřív psala syrový kód („3D tisk → standard").
 *
 * Přednost má název rungu z téže nabídky (stejný text, jaký má zákazník
 * na tlačítku); když tam ten rung není (schovaný jako nerozlišitelný),
 * vezme se název kapacitního stupně, na kterém operace skutečně jede.
 * Kód se zákazníkovi neukáže nikdy — bez názvu vrací ``null``.
 */
export function fallbackRungLabel(
  opt: CartDeliveryLadderOption,
  fallback: CartLadderFallback,
  options: readonly CartDeliveryLadderOption[],
  lang: string | undefined,
): string | null {
  const rung = options.find(
    (o) => o.ladder_code === fallback.actual_ladder_code,
  );
  if (rung) {
    const label = pickI18nBlob(
      rung.ladder_label_i18n,
      rung.ladder_label_cz,
      rung.ladder_label_en,
      lang,
    );
    if (label) return label;
  }
  const tier = opt.per_capacity.find(
    (c) => c.process_type === fallback.process_type,
  );
  if (tier) {
    const label = pickI18nBlob(
      tier.label_i18n,
      tier.label_cz,
      tier.label_en,
      lang,
    );
    if (label) return label;
  }
  return null;
}
